export enum UserRole {
    Admin = 'Admin',
    User = 'User',
    Teacher = 'Teacher',
    Manager = 'Manager'
}    
